// store/snackbarSlice.js
import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    open: false,
    message: "",
    severity: "success", // "success" | "error" | "warning" | "info"
    styles: {},
    position: { vertical: "top", horizontal: "center" },
};

const snackbarSlice = createSlice({
    name: "snackbar",
    initialState,
    reducers: {
        showSnackbar: (state, action) => {
            const { message, severity, styles = {}, position = false } = action.payload;
            state.open = true;
            state.message = message;
            state.severity = severity || "success";
            state.styles = styles;
            state.position = position || { vertical: "top", horizontal: "center" };
        },
        hideSnackbar: (state) => {
            state.open = false;
        },
        resetSnackbarStyles: (state) => {
            state.styles = {};
            state.position = { vertical: "top", horizontal: "center" };
            state.severity = "success";
            state.message = "";
        }
    },
});

export const { showSnackbar, hideSnackbar, resetSnackbarStyles } = snackbarSlice.actions;
export default snackbarSlice.reducer;
